import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useListsStore } from '@shared/model'

import { useTutorKanbanStore } from './store'

interface TutorKanbanPreviousStageReturn {
  refLabel: ComputedRef<string>
}

export const useTutorKanbanPreviousStage = (): TutorKanbanPreviousStageReturn => {
  const tutorKanbanStore = useTutorKanbanStore()
  const listsStore = useListsStore()

  const refLabel = computed<string>(() => {
    const stage = tutorKanbanStore.getTutor?.previous_stage
    if (!stage) {
      return '—'
    }
    const list = listsStore.getTutor?.stage ?? {}
    return list[stage] ?? stage
  })

  return {
    refLabel,
  }
}
